import React, { } from "react";
import { Container, Card, Row, Col, } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TimeLineChart from "../TimeLine_Chart/Timeline_Chart";
import { useNavigate } from "react-router-dom";
import HeaderVector from './../../assets/header-vector.svg';
import Service from './../../assets/service.svg';
import MaskGroup from './../../assets/MaskGroup.png';
import styles from './style.module.css';

function AttendantService(props) {
    let navigate = useNavigate();
    return (
        <>
            <div style={{ backgroundImage: "url(" + MaskGroup + ")", backgroundSize: "contain" }}>
                <Row className="offset-lg-1 col-lg-10">
                    <Col>
                        <div className="container">
                            <Row>
                                <Col className={"col-12 col-sm-12 col-md-12 col-lg-6 " + styles.centerImage}>
                                    <img src={HeaderVector} alt="React Logo" width={"75%"} />
                                </Col>
                                <Col className={"col-12 col-sm-12 col-md-12 col-lg-6 align-self-center"}>
                                    <h1 className="text-center mt-3" style={{
                                        fontSize: "30px",
                                        fontWeight: "bolder",
                                        fontFamily: "Raleway"
                                    }}                         >Home Trial - Attendant Service</h1>
                                    <div className="text-center" >
                                        <h6>Find great care  thats  fits your needs</h6>
                                        <div className={styles.trialBtnDiv}>
                                            <button onClick={() => {
                                                navigate('booking');
                                            }} className={styles.trialBtn}>
                                                Book Home Trial @ ₹299
                                            </button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>
            {/* <div className="mt-2 text-center">
                <img style={{ borderRadius: 15 }} width={window.innerWidth > 700 ? "500" : window.innerWidth - 20} alt="" src="https://i0.wp.com/care24.co.in/wp-content/uploads/2022/06/attendant-3.jpg?fit=1000%2C557&ssl=1"></img>
            </div> */}
            <TimeLineChart></TimeLineChart>
            {/* <Container className={window.innerWidth > 700 ? "text-start mt-3 col-8 offset-2" : "text-start mt-3"} >
                <Row>
                    <Col className="col-4" style={{ padding: "0px" }}>
                        <Container className=" text-center" style={{ padding: "3px" }} >
                            <Card className="p-2" style={{ height: "100px", backgroundColor: "#e9f2f8", color: "#2b7dbd" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" style={{ width: "100%" }} fill="currentColor" className="bi bi-star" viewBox="0 0 16 16"><path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288L8 2.223l1.847 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.565.565 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z"></path></svg>
                                <div style={{ fontSize: "11px" }}>376056 patients</div>
                            </Card>
                        </Container>
                    </Col>
                    <Col className="col-4" style={{ padding: "0px" }}>
                        <Container className=" text-center" style={{ padding: "3px" }} >
                            <Card className="p-2" style={{ height: "100px", backgroundColor: "#e9f2f8", color: "#2b7dbd" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" style={{ width: "100%" }} fill="currentColor" className="bi bi-patch-check" viewBox="0 0 16 16"><path fillRule="evenodd" d="M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"></path><path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"></path></svg>
                                <div style={{ fontSize: "11px" }}>Background verified</div>
                            </Card>
                        </Container>
                    </Col>
                    <Col className="col-4" style={{ padding: "0px" }}>
                        <Container className=" text-center" style={{ padding: "3px" }} >
                            <Card className="p-2" style={{ height: "100px", backgroundColor: "#e9f2f8", color: "#2b7dbd" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" style={{ width: "100%" }} fill="currentColor" className="bi bi-lightbulb" viewBox="0 0 16 16"><path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1z"></path></svg>
                                <div style={{ fontSize: "11px" }}>Experienced Caregivers</div>
                            </Card>
                        </Container>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-4" style={{ padding: "0px" }}>
                        <Container className=" text-center" style={{ padding: "3px" }} >
                            <Card className="p-2" style={{ height: "100px", backgroundColor: "#e9f2f8", color: "#2b7dbd" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" style={{ width: "100%" }} fill="currentColor" className="bi bi-file-earmark-medical" viewBox="0 0 16 16"><path d="M7.5 5.5a.5.5 0 0 0-1 0v.634l-.549-.317a.5.5 0 1 0-.5.866L6 7l-.549.317a.5.5 0 1 0 .5.866l.549-.317V8.5a.5.5 0 1 0 1 0v-.634l.549.317a.5.5 0 1 0 .5-.866L8 7l.549-.317a.5.5 0 1 0-.5-.866l-.549.317V5.5zm-2 4.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"></path><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"></path></svg>
                                <div style={{ fontSize: "11px" }}>Medical certified</div>
                            </Card>
                        </Container>
                    </Col>
                    <Col className="col-4" style={{ padding: "0px" }}>
                        <Container className=" text-center" style={{ padding: "3px" }} >
                            <Card className="p-2" style={{ height: "100px", backgroundColor: "#e9f2f8", color: "#2b7dbd" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" style={{ width: "100%" }} fill="currentColor" className="bi bi-clock-history" viewBox="0 0 16 16"><path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"></path><path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"></path><path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"></path></svg>
                                <div style={{ fontSize: "11px" }}>24x7 Assistance</div>
                            </Card>
                        </Container>
                    </Col>
                    <Col className="col-4" style={{ padding: "0px" }}>
                        <Container className=" text-center" style={{ padding: "3px" }} >
                            <Card className="p-2" style={{ height: "100px", backgroundColor: "#e9f2f8", color: "#2b7dbd" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" style={{ width: "100%" }} fill="currentColor" className="bi bi-dash-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path><path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"></path></svg>
                                <div style={{ fontSize: "11px" }}>0 fee Cancellation</div>
                            </Card>
                        </Container>
                    </Col>
                </Row>
            </Container> */}
            <div className="offset-lg-1 col-lg-10">
                <div style={{ fontSize: "25px", fontWeight: "bold" }} className="text-center pt-3 mb-2">Service Features</div>
                <div className="container">
                    <div style={{
                        // color: "#54595f",
                        fontSize: 12,
                        fontWeight: 400
                    }} className="text-center ps-2 pe-2">Our attendants are medically trained and Care24 certified caregivers. They’re able to help patients with:</div>

                    <div className="mb-3 mt-3">
                        <Row>
                            <Col className={"col-12 col-lg-4 col-md-12 col-sm-12 col-xs-12"}>
                                <Row className="pt-2 pb-2">
                                    <div className="col-2 text-end">
                                        <FontAwesomeIcon icon="check" color="#2b7dbd" />
                                    </div>
                                    <div className="col-10" style={{

                                        fontSize: 14,
                                        fontWeight: 400
                                    }}>Background verification</div>
                                </Row>
                                <Row className="pt-2 pb-2">
                                    <div className="col-2 text-end">
                                        <FontAwesomeIcon icon="check" color="#2b7dbd" />
                                    </div>
                                    <div className="col-10" style={{

                                        fontSize: 14,
                                        fontWeight: 400
                                    }}>Bed Bath/Sponge Bath</div>
                                </Row>
                                <Row className="pt-2 pb-2">
                                    <div className="col-2 text-end">
                                        <FontAwesomeIcon icon="check" color="#2b7dbd" />
                                    </div>
                                    <div className="col-10" style={{

                                        fontSize: 14,
                                        fontWeight: 400
                                    }}>Cleanliness of patient’s room</div>
                                </Row>
                                <Row className="pt-2 pb-2">
                                    <div className="col-2 text-end">
                                        <FontAwesomeIcon icon="check" color="#2b7dbd" />
                                    </div>
                                    <div className="col-10" style={{

                                        fontSize: 14,
                                        fontWeight: 400
                                    }}>
                                        Feeding assistance</div>
                                </Row>
                            </Col>
                            <Col className={[styles.serviceImage, "col-lg-4 text-center"]}>
                                <img src={Service} alt="React Logo" width={150} height={200} />
                            </Col>
                            <Col className={"col-12 col-lg-4 col-md-12 col-sm-12 col-xs-12"} >
                                <Row className="pt-2 pb-2">
                                    <div className="col-2 text-end">
                                        <FontAwesomeIcon icon="check" color="#2b7dbd" />
                                    </div>
                                    <div className="col-10" style={{

                                        fontSize: 14,
                                        fontWeight: 400
                                    }}>Bathroom assistance</div>
                                </Row>
                                <Row className="pt-2 pb-2">
                                    <div className="col-2 text-end">
                                        <FontAwesomeIcon icon="check" color="#2b7dbd" />
                                    </div>
                                    <div className="col-10" style={{

                                        fontSize: 14,
                                        fontWeight: 400
                                    }}>Walking and home exercise assistance</div>
                                </Row>
                                <Row className="pt-2 pb-2">
                                    <div className="col-2 text-end">
                                        <FontAwesomeIcon icon="check" color="#2b7dbd" />
                                    </div>
                                    <div className="col-10" style={{

                                        fontSize: 14,
                                        fontWeight: 400
                                    }}>Mobility in bed for bedridden</div>
                                </Row>
                                <Row className="pt-2 pb-2">
                                    <div className="col-2 text-end">
                                        <FontAwesomeIcon icon="check" color="#2b7dbd" />
                                    </div>
                                    <div className="col-10" style={{

                                        fontSize: 14,
                                        fontWeight: 400
                                    }}>Companionship with polite conversations</div>
                                </Row>
                            </Col>
                        </Row>
                    </div>

                    {window.innerWidth > 700 && <div className="text-center" >
                        <div>
                            <button onClick={() => {
                                navigate('booking');
                            }} className="p-2" style={{
                                fontSize: "19px", fontWeight: 600,
                                width: "395", border: "none", color: "white",
                                backgroundColor: "#2b7dbd", borderRadius: "7px"
                            }}>
                                Book Home Trial @ ₹299
                            </button>
                        </div>
                    </div>}
                </div>
            </div>
        </>
    );
}

export default AttendantService